import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from '../Menu';
import { Select } from '../Select';
import { Skeleton } from '../Skeleton';
/**
 * Select constructed by incoming data replaced with Skeleton while data is undefined.
 */
const Lookup = ({ items, keyField, labelField, value, autoFocus, disabled, isLoading, onChange, }) => {
    // if (!items) return <Skeleton fullWidth variant="rounded" height="input" />;
    if (isLoading)
        return _jsx(Skeleton, { fullWidth: true, variant: "rounded", height: "input" });
    return (_jsx(Select, { fullWidth: true, value: value ?? '', autoFocus: autoFocus, disabled: disabled, onChange: onChange, children: items?.map((item) => {
            const key = item[keyField];
            const label = item[labelField];
            return (_jsx(MenuItem, { value: key, children: label }, key));
        }) }));
};
export { Lookup };
